<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Customer Audit</div>
        <div>
          <bread-crumb :bread-crumbs="['Customer Audit']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="2" xs="12">
            <!-- <label class="font-weight-large my-0">Customer Name</label> -->
            <v-text-field
              placeholder="Customer Name"
              v-model="username"
              :items="customerLogsList"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="2" lg="2" xs="12">
          <label class="font-weight-large my-0">To</label>
          <v-text-field type="date" dense outlined></v-text-field>
        </v-col> -->

          <div class="d-flex">
            <v-btn depressed 
              small
              class="text-capitalize"
              color="primary"
              @click="getCustomeraduitlogdata()"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
          :items="customerLogsList"
          dense
          class="mt-6"
        >
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Customer Audit",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    headers: [
      { text: "SNo", value: "SNo", align: "start" },
      { text: "Customer Name", value: "Customer_Name" },
      { text: "Label Name", value: "Partner_ID" },
      { text: "Old Value", value: "Function_Name" },
      { text: "New Value", value: "Date" },
      { text: "Modified By", value: "User" },
      { text: "Modified Date", value: "Delete", align: "center" },
    ],
    customerLogsList: [],
    loaderOverlay: false,
    search: "",
    username: "",
  }),
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getCustomeraduitlogdata() {
      this.loaderOverlay = true;
      try {
        const params = {
          username: this.username,
          skip: 0,
          limit: 50,
        };
        const response = await userService.getCustomeruserlog(params);
        if (response.status === 200) {
          this.customerLogsList = response.data;
          console.log("customerdata", this.customerLogsList);
          this.stoploader();
        }
        //  else if (response.status === 401) {
        //   this.customerLogsList = [];
        //   this.returnNewToken();
        //   this.getCustomeraduitlogdata();
        //   this.stoploader();
        // } 
        else {
          this.customerLogsList == [];
          this.stoploader();
        }
      } catch (error) {
        this.customerLogsList = [];
        this.stoploader();
        console.error(error);
      }
    },
    // getCustomeraduitlogdata() {
    //   this.isloadagents = true;
    //   let url = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin/customer-audit-logs-data`;
    //   axios({
    //     url: url,
    //     method: "GET",
    // params: {
    //   username: this.username,
    //   skip: 0,
    //   limit: 50,
    // },
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
    //     },
    //   })
    //     .then((response) => {
    //       this.isloadagents = false;
    // if (response.status === 200) {
    //   this.customerLogsList = response.data;
    // }
    //       console.log("customerdata", response);
    //     })
    //     .catch((e) => {
    //       this.isloadagents = false;
    //       console.error(e);
    //     });
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
</style>
